export enum DoughnutTabType {
    amount,
    count
}
